import type { ApPoLineItem } from "@/accounts-payable/types";
import { humanizePoField, formatApDate } from "@/accounts-payable/utils";
/** "Pricebook Equipment" / "new purchase order" → "Pricebook equipment" / "New purchase order". */
export const sentenceCase = (text: string) =>
  text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

/** PO fields whose values run long get a full row instead of a grid cell. */
const PO_WIDE_FIELDS = new Set(["memo", "shipTo"]);

const PO_DATE_FIELDS = new Set(["date", "requiredOn"]);

/** Build the record card's field groups without mixing payload parsing into JSX. */
export const getPoRecordFields = (
  changes: Record<string, string | ApPoLineItem[]>,
) => {
  const entries = Object.entries(changes);
  const scalars = entries.filter(
    (entry): entry is [string, string] => !Array.isArray(entry[1]),
  );
  const fields = scalars.map(([key, value]) => ({
    key,
    label: humanizePoField(key),
    value: PO_DATE_FIELDS.has(key)
      ? formatApDate(String(value))
      : String(value),
    wide: PO_WIDE_FIELDS.has(key),
  }));
  const items = entries.find(([, value]) => Array.isArray(value))?.[1];
  return {
    short: fields.filter((field) => !field.wide),
    wide: fields.filter((field) => field.wide),
    items: Array.isArray(items) ? items : undefined,
  };
};
